export const General = {
  instagram: 'https://www.instagram.com/centaura.restaron ',
  facebook: 'https://www.facebook.com/share/zFczNfNaig9Rxyfv/?mibextid=LQQJ4d',
  googleApiKey: 'AIzaSyApBEBocUtOkfjXRZYfZ21eszsl4la6Xd0',
  parajanov: 'https://parajanov.com.ua/',
  babogardens: 'https://babogardens.com.ua/',
  monspius: 'https://monspius.com.ua/',
  libraria: 'https://libraria.com.ua/',
  phone: '(096) 188-24-45',
  gAnalyticId: 'G-F6E6J0TG85',
}


